import { createSlice } from "@reduxjs/toolkit";
import { getDashboardDataAction } from "../../actions/dashboard/dashboardAction";




const DashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    chartData: [],
    caseCount: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardDataAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardDataAction.fulfilled, (state, action) => {
        state.loading = false;
        state.caseCount = action.payload.caseCount || [];
        state.chartData = action.payload.chartData || [];
      })
      .addCase(getDashboardDataAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default DashboardSlice.reducer;
